import React from 'react';
import {
  styled,
  Dialog,
  Button,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Typography,
} from '@nextiva/next-ui-components';

interface InformationDialogProps {
  open: boolean;
  handleClose: () => void;
  dataTestId: string;
  title: string;
  content: string | React.ReactElement;
}

export const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 8px;
    padding: 32px;
    width: 411px;
  }
  & .MuiDialogContent-root {
    padding: 0;
  }
  div.MuiDialogActions-root {
    padding: 0;
  }
`;
const StyledDialogContent = styled(DialogContent)`
  margin: 32px 0;
`;

const StyledDoneButton = styled(Button)`
  width: 83px;
  height: 40px;
  line-height: 1rem;
  &.MuiButtonBase-root {
    padding: 12px 24px;
  }
`;

const StyledContentTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

export function InformationDialog({
  open,
  handleClose,
  dataTestId,
  title,
  content,
}: InformationDialogProps) {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle style={{ padding: 0 }}>{title}</DialogTitle>
      <StyledDialogContent>
        <DialogContentText id="dialog-description">
          <StyledContentTypography variant="body2">
            {content}
          </StyledContentTypography>
        </DialogContentText>
      </StyledDialogContent>
      <DialogActions>
        <StyledDoneButton
          onClick={handleClose}
          data-testid={dataTestId}
          variant="contained"
          size="medium"
        >
          Done
        </StyledDoneButton>
      </DialogActions>
    </StyledDialog>
  );
}

export default InformationDialog;
